var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContinuePlayingIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cp-1",
    d: "M7,32c0-8.93,4.77-17.18,12.5-21.65s17.27-4.47,25,0,12.5,12.72,12.5,21.65-4.77,17.18-12.5,21.65-17.27,4.47-25,0-12.5-12.72-12.5-21.65ZM25.39,21.36c-.74.41-1.2,1.2-1.2,2.04v17.19c0,.85.46,1.63,1.2,2.04.74.41,1.64.4,2.37-.05l14.06-8.59c.69-.43,1.12-1.18,1.12-2s-.43-1.57-1.12-2l-14.06-8.59c-.72-.44-1.63-.46-2.37-.05v.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuePlayingIc);
export default __webpack_public_path__ + "static/media/continuePlayingIc.1b47f05e5ae03095dfaf52e6dbd5752a.svg";
export { ForwardRef as ReactComponent };